<template>
  <div class="account-right-item attention">
    <h4>我的粉丝: <span>{{page.total}}人</span></h4>
    <div  v-if="page.total!=0">
      <ul class="wrapper-list clearfix">
        <li class="clearfix" v-for="item in fans_list">
          <a href="javascript:;" class="fl images-box">
            <img :src="item.avatar_url" alt="" width="60" height="60" v-if="item.avatar_url.indexOf('?')!==0"/>
            <img src="../../../images/personal_center/avatar_default.png" alt="" width="60" height="60" v-else/>
          </a>
          <div class="fl info-box">
            <a href="javascript:;"><h5 class="toe" :title="item.nick_name">{{item.nick_name}}</h5></a>
            <p>{{item.focus.day}}开始关注你</p>
            <p v-if="item.each_other">
              <span class="icon" :class="{'focused':!item.each_other}"></span>
              <span>互相关注</span>，
              <a href="javascript:;" @click="unfollow(item.user_id,item)">取消</a>
              <a href="javascript:;" class="massage-text" @click="showBox(item.user_id, item.nick_name)">留言</a>
            </p>
            <p v-else>
              <span class="follow" @click="follow(item.user_id, item)"><span class="icon focus"></span> 立即关注</span>
              <a href="javascript:;" class="massage-text" @click="showBox(item.user_id, item.nick_name)">留言</a>
            </p>
          </div>
        </li>
      </ul>
      <button type="button" class="more" :disabled="use" v-show="page.totalPage > 1" @click="more(page)">{{button.tip}}</button>
    </div>
    <div class="attention-null" v-else>
      <img src="../../../images/personal_center/work-null.png" alt="" />
      <p>暂时没有人关注你哦~</p>
    </div>

    <div class="attention-pops" v-if="msgBox.status">
      <div class="pops-content">
        <div class="message">
          <h4>给 <router-link class="user" :to="{path:'/s-mart/personal/'+msgBox.user_id+'/'}">{{msgBox.nick_name}}</router-link> 留言<a class="fr pops-close" href="javascript:;" @click="closeBox"><img src="../../../images/personal_center/pops-close.png" alt="" /></a></h4>
          <div class="msg-box">
            <textarea class="msg" placeholder="在此输入你的留言内容..." name="msg" v-model="msg.content" maxlength="200"></textarea>
          </div>
          <div class="send clearfix" v-if="msg_list[msgBox.user_id].status">
            <p v-if="200 - msg.content.length>=0">还可以输入 <span class="number">{{200 - msg.content.length}}</span> 个字符</p>
            <p v-else>已超出 <span class="number">{{msg.content.length - 200}}</span> 个字符</p>
            <a class="send-msg" href="javascript:void(0);" @click="sendMsg" v-if="!msg.isSubmit">发送</a>
            <a class="send-msg" href="javascript:void(0);" v-else><img class="loading" src="../../../images/common/loading_16.svg" alt="">提交中</a>
          </div>
          <div class="wait" v-else>
            发送留言成功，<span class="time">{{curCount.count | formatTime}}</span>后可继续留言
          </div>
        </div>
      </div>
    </div>
    <v-alert :options="options"></v-alert>
  </div>
</template>

<script type="text/javascript">
  import vAlert from "../../alert.vue";
  export default {
    filters: {
      formatTime(data) {
        if (data < 60) {
          return data + "秒";
        }else if(data < 70){
          return "1分0" + (data - 60) + "秒";
        }else {
          return "1分" + (data - 60) + "秒";
        }
      }
    },
    data() {
      return {
        fans_list: [],  //粉丝列表
        page: {},
        button:{
          tip:"加载更多"
        },
        use:false,

        msgBox: {      // 留言弹窗
          status: false,   // 是否显示留言框,
          nick_name: '',
          user_id: ''
        },
        msg: {    // 消息相关
          content: '',
          isSubmit: false,  //是否处于提交中
          during: 119,  // 2分钟发一次
        },
        curCount: {  //当前定时器相关
          count: 0,       // 当前计时
          timer: null,   // 定时器
          status: false  // 是否可留言
        },
        msg_list: {},  // 定时器列表

        options: {}
      }
    },
    methods: {
      sendMsg() {  // 留言
        if (this.msg.content.length<=0) {
          this.options = {
            msgIsSuccess: false,
            msgText: "请输入留言内容"
          }
          return ;
        }
        if (this.msg.content.trim() === "") {
          this.options = {
            msgIsSuccess: false,
            msgText: "输入内容不能为空"
          }
          return ;
        }
        if (this.msg.content.length>200) {
          this.options = {
            msgIsSuccess: false,
            msgText: "内容长度不合法"
          }
          return ;
        }
        let uid = this.msgBox.user_id;
        this.msg.isSubmit = true;
        axios.post(myUrl + "sns/message/leave/" + this.msgBox.user_id + "/", qs.stringify({
          content: this.msg.content
        })).then((res) => {
          res = res.data;
          if (res.result) {
            let curMsg = this.msg_list[uid];
            curMsg.status = false;
            curMsg.count = this.msg.during;
            console.log(curMsg);
            curMsg.timer = setInterval(() => {
              curMsg.count--;
              if (curMsg.count <= 0) {
                clearInterval(curMsg.timer);
                curMsg.count = this.msg.during;
                curMsg.timer = null;
                curMsg.status = true;
              }
            }, 1000)
            this.curCount = this.msg_list[uid];
          }else {
            this.options = {
              msgText: "留言失败，请稍后重试",
              msgIsSuccess: false
            }
          }
          this.msg.isSubmit = false;
        }).catch(() => {
          this.msg.isSubmit = false;
        })
      },
      /*
        nick_name: 对话框用户名,
        user_id: 对话框用户id
      */
      showBox(user_id, nick_name) {
        this.msgBox.nick_name = nick_name;
        this.msgBox.user_id = user_id;
        this.msgBox.status = true;  // 显示留言框
        if (!this.msg_list[user_id]) {
          this.msg_list[user_id] = {
            status: true,
            count: this.msg.during,
            timer: null
          }
        }
        this.curCount = this.msg_list[user_id];
      },
      /**/
      closeBox() {
        this.msg.content = '';
        this.msgBox.status = false;  // 关闭留言框
      },
      //关注
      follow(useId,item){
        axios.post(myUrl + 'sns/star/user/' + useId + "/").then((res) =>{
          res = res.data;
          if(res.result){
            item.each_other = 1;
            this.fans_list.splice();
          }else{
            console.log(res.message);
          }
        })
      },
      // 取消关注
      unfollow(useId,item){
        axios.post(myUrl + 'sns/unstar/user/' + useId + "/").then((res) =>{
          res = res.data;
          if(res.result){
            item.each_other = 0;
            this.fans_list.splice();
          }else{
            console.log(res.message);
          }
        })
      },
      // 获取粉丝数据
      getFansList() {
        axios.post(myUrl + 'sns/fan/user/').then((res) =>{
          res = res.data;
          if(res.result){
            this.page = res.data.page;
            this.fans_list = res.data.items;
          }else{
            console.log(res.message);
          }
        })
      },
      // 获取更多
      more(page){
        this.page.curPage++;
        axios.post(myUrl + 'sns/fan/user/', qs.stringify({"page":this.page.curPage})).then((res)=>{
          res =  res.data;
          if (res.result){
            this.fans_list = this.fans_list.concat(res.data.items);
            if(res.data.page.curPage == res.data.page.totalPage){
              this.button.tip = "没有更多内容了";
              this.use = true;
            }
          } else {
            console.log(res.message);
          }
        })
      }
    },
    mounted() {
      this.getFansList();
    },
    components: {
      vAlert
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .more{
    display:block;
    width: 100%;
    height: 42px;
    line-height: 42px;
    border: 1px solid #f4f4f4;
    text-align: center;
    font-size: 14px;
    color: #828282;
    background: #fff;
    outline:none;
    &:hover{
      background: #fafafa;
    }
  }
</style>



// WEBPACK FOOTER //
// fans.vue?6e07c237